import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '@/context/auth-context'

const SESSION_STORAGE_KEY = 'shop_banner_active'
const SESSION_STORAGE_DISMISSED_KEY = 'shop_banner_dismissed'

export const useShopBanner = () => {
  const { user } = useAuth()
  const [isBannerVisible, setIsBannerVisible] = useState(false)

  useEffect(() => {
    // Check if banner should be visible
    const isActive = sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true'
    const isDismissed = sessionStorage.getItem(SESSION_STORAGE_DISMISSED_KEY) === 'true'
    const hasShopAccess = user?.access_shop !== false

    setIsBannerVisible(isActive && !isDismissed && hasShopAccess)
  }, [user])

  const dismissBanner = useCallback(() => {
    sessionStorage.setItem(SESSION_STORAGE_DISMISSED_KEY, 'true')
    setIsBannerVisible(false)
  }, [])

  return {
    isBannerVisible,
    dismissBanner,
  }
}

// Utility function to activate the banner (called when modal is shown)
export const activateShopBanner = () => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, 'true')
}
